import { useEffect, useRef } from "react";
import { useServices } from "@/app/use-services";
import type { Moment } from "@/lib/analytics/analytics";

/**
 * Records `moment` once for as long as the screen stays mounted, and again
 * only when the moment itself changes (another period, another reading).
 * Pass null while the thing it describes is not on screen yet.
 */
export function useMomentOnce(moment: Moment | null): void {
  const { analytics } = useServices();
  const key = moment ? JSON.stringify(moment) : null;
  const sent = useRef<string | null>(null);
  useEffect(() => {
    if (!moment || key === null || key === sent.current) return;
    sent.current = key;
    analytics.track(moment);
    // `key` stands for `moment`: a new object with the same content is the same moment.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, analytics]);
}
